import React, { Fragment, useEffect, useRef } from 'react'
import Button from '../Button'
import Icon, { IconType } from '../Icon'
import Col from '../Col'
import Row from '../Row'
import fileSize from '@bt-react/libs/fileSize'
import { ProcessingFileProps } from './types'
import styles from '@bt-react/styles'
import componentStyles from './ProcessingFile.module.scss'
import { Progress } from 'reactstrap'
import classNames from 'classnames'
import { useIsNarrowView } from '../Attachments/Attachments'

const ProcessingFile: React.FC<ProcessingFileProps> = ({channelId, webcastId, status, data, readonly, setView, selectAttachment, deleteResource, isCentral}) => {

    const {file, link} = data

    const id = data.target ? data.target.id : data.id
    const fileId = useRef(id)
    const UploadStatus = useRef(status.isUploading)

    useEffect(() => {
        fileId.current = data.target ? data.target.id : data.id
        UploadStatus.current = status.isUploading
    }, [data.target, data.id, status])

    const isNarrowView = useIsNarrowView()

    return (
        <div className={componentStyles['attachments-item-container']} data-bdd="attachments-processing">
            <Row>
                <Col xs={8}>
                    <Icon name={file ? IconType.iconName.file : IconType.iconName.link} className={componentStyles['attachment-icon']}/>
                    {data.title}
                </Col>
                {file &&
                    <Col xs={4}>
                        <span className={componentStyles['file-size']}>{file.size ? fileSize(file.size, true) : ''}</span>
                    </Col>
                }
            </Row>
            {!status.isUploading &&
                <Row className={styles['pt-3']}>
                    {!status.isProcessing && link &&
                        <Col xs={8}>
                            <a href={link.href}>{link.href}</a>
                        </Col>
                    }
                    {status.isProcessing && !status.hasError &&
                        <Col xs={8}>
                            <Icon name={IconType.iconName.spinner} className={componentStyles['spinner-icon']}/>
                            Processing file...
                        </Col>
                    }
                    {status.isProcessing && status.hasError &&
                        <Col xs={8} className={componentStyles['alert-message']}>
                            <Icon name={IconType.iconName.dangerCentral} className={componentStyles['danger-icon']}/>
                            Error processing file. Please try again.
                        </Col>
                    }
                    {!readonly && !status.isProcessing &&
                        <Col xs={{ size: isNarrowView ? 12 : 4, offset: link || status.isProcessing ? 0 : 8 }} className={componentStyles['action-icons']}>
                            <span onClick={()=>{
                                setView('add')
                                selectAttachment(data)
                            }}>
                                <Icon name={isCentral ? IconType.iconName.pencilRegular : IconType.iconName.pencil} className={componentStyles['action-icon']}/>
                            </span>
                            <span onClick={()=>{
                                setView('delete', true)
                                selectAttachment(data)
                            }}>
                                <Icon name={isCentral ? IconType.iconName.trashRegular : IconType.iconName.trash} className={componentStyles['action-icon']}/>
                            </span>
                            <Icon name={IconType.iconName.bars} className={classNames(componentStyles['action-icon'], 'handle-bar', componentStyles['burger-icon'])}/>
                        </Col>
                    }
                </Row>
            }
            {status.isUploading && data.file &&
                <Fragment>
                    <Progress
                        value={data.file.percent ? data.file.percent : 0}
                        className={componentStyles['upload-progress']}
                        barClassName={componentStyles['upload-main-progress']}
                        cssModule={styles}
                    />
                    <Row className={componentStyles['upload-progress-status']}>
                        <Col xs={9}>
                            Transfer rate {fileSize(data.transferRate ? data.transferRate : 0, true)}/s
                        </Col>
                        <Col xs={3} className={styles['text-right']}>
                            {data.file.percent ? data.file.percent : 0}%
                        </Col>
                    </Row>
                    <Row className={componentStyles['upload-status']}>
                        <Col xs={9} className={componentStyles['upload-status-text']}>
                            Upload in progress!
                        </Col>
                        <Col xs={3} className={styles['text-right']}>
                            <Button
                                onClick={()=>{
                                    deleteResource(channelId, webcastId, data.target ? data.target.id : data.id, 'cancel' )
                                }}
                                color={IconType.colour.link}
                                text="Cancel"
                                className={componentStyles['cancel-btn']}
                            />
                        </Col>
                    </Row>
                </Fragment>
            }
        </div>
    )

}

export default ProcessingFile